export const magazines = [
    {
      id: 1,
      name: "Salsabeel",
      description: "A spiritual and educational magazine",
      details: "",
      color: "#d4f5e9",
      icon: "🕌"
    },
    {
      id: 2,
      name: "Ar rushd",
      description: "Academic research and scholarly articles",
      details: "",
      color: "#dbeafe",
      icon: "📚"
    },
    {
      id: 3,
      name: "General",
      description: "In-depth research on Islamic studies",
      details: "",
      color: "#f3e8ff",
      icon: "🧑‍🎓"
    }
  ];
  